import { Component, OnInit, Input, ViewChild } from '@angular/core';

import { ConfirmationService, MenuItem } from 'primeng/api';
import { MessageService } from 'primeng/api';

// Export
import * as FileSaver from 'file-saver';
import { ExportService } from 'src/app/shared/services/export.service';

// Model
import { Table } from 'primeng/table';
import { ScaleCrudService } from 'src/app/shared/services/scale-crud.service';
import { Scale } from 'src/app/shared/interfaces/scale';


@Component({
  selector: 'app-scales',
  templateUrl: './scales.component.html',
  styleUrls: ['./scales.component.scss']
})
export class ScalesComponent implements OnInit {

  scales: Scale[];
  scale: Scale;
  selectedScales: Scale[] = [];

  scaleDialog: boolean = false;

  submitted: boolean = false;

  // column management
  cols: any[] = [];
  _selectedColumns: any[] = [];

  // export
  @ViewChild('dt', {static: true}) dt : any;
  exportColumns: any[] = [];

  // ui beadcrumb
  breadcrumbs: MenuItem[];
  homeBreadcrumb: MenuItem = {} as MenuItem;

  hideWhenNoPallet: boolean = false;
  noData: boolean = false;
  preLoader: boolean = true;

  separatorExp: string = "[,| ]";

  constructor(
    private scaleService : ScaleCrudService,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private exportService: ExportService
  ) { 
    // ui breadcrumbs
    this.breadcrumbs = [
      {label: 'Settings'},
      {label: 'Scales'}
    ];

    this.scales = [];
    this.scale = { } as Scale ;
  }

  ngOnInit(): void {

    this.isFilter = false;
    
    this.dataState();
    let s = this.scaleService.getList(); 
    s.snapshotChanges().subscribe(data => {
      this.scales = [];
      data.forEach(item => {
        let jsonItem : { '$key': string | null } = item.payload.toJSON() as { '$key': string | null } ; 
        if (jsonItem) {
          if (jsonItem) {
            jsonItem['$key'] = item.key;
          }
          let l : Scale = jsonItem as Scale;
          if (l.tags) {
            l.tags = Object.values(l.tags);
          }
          this.scales.push(l);
        }
      })
    })

    // column management
    this.cols = [
      { field: 'name', header: 'Name' },
      { field: 'qrcode', header: 'QRCode' },
      { field: 'description', header: 'Description' },
      { field: 'tags', header: 'Tags' },
      { field: 'isEnabled', header: 'Enabled' },
      { field: 'actions', header: 'Actions' } 
    ];

    // column that we shoa at the beginning
    this._selectedColumns = this.cols;
    this._selectedColumns = this._selectedColumns.filter( item => item.field !== 'qrcode');
    this._selectedColumns = this._selectedColumns.filter( item => item.field !== 'description');
   // this._selectedColumns = this._selectedColumns.filter( item => item.field !== 'isEnabled');

    // Exports
   // this.exportColumns = this.cols.map(col => ( {title: col.header, dataKey: col.field} ) );
   // For the PDF 
   this.exportColumns = this.cols.map(col => {
      if (col.field === 'position' || col.field === 'rank')  
        return {title: col.header, dataKey: 'position'};
      if (col.field !== 'actions')  
        return {title: col.header, dataKey: col.field};
      return {};
    } );
  }

  dataState() {     
    this.scaleService.getList().valueChanges().subscribe(data => {
      this.preLoader = false;
      if(data.length <= 0){
        this.hideWhenNoPallet = false;
        this.noData = true;
      } else {
        this.hideWhenNoPallet = true;
        this.noData = false;
      }
    })
  }

  includesCol(val: string) : boolean{
    let c = this._selectedColumns.find(c => c.field === val);
    return c;
  }

  // Column management
  @Input() get selectedColumns(): any[] {
    // console.log('selected columns', this._selectedColumns);
    return this._selectedColumns;
  }
  set selectedColumns(val: any[]) {
    //restore original order
    // console.log('before selected columns', this._selectedColumns);
    // console.log('before cols', this._selectedColumns);
    this._selectedColumns = this.cols.filter(col => val.includes(col));
    // console.log('after selected columns', this._selectedColumns);
  }

  // Export management
  exportPdf() {
    import("jspdf").then(jsPDF => {
        import("jspdf-autotable").then(x => {
            const doc = new jsPDF.default('l','pt');
            // @ts-ignore
            doc.autoTable(this.exportColumns, this.scales);
            doc.save('scales.pdf');
        })
    })
  }

  exportExcel() {
    import("xlsx").then(xlsx => {
        const worksheet = xlsx.utils.json_to_sheet(this.scales);
        const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
        const excelBuffer: any = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
        this.saveAsExcelFile(excelBuffer, "scales");
    });
  }

  exportDTCSV() {
   // console.log('export csv');
    this.dt.exportCSV();
  }

  exportToCsv(): void {
    let exportCols : string[] = [];
    this.selectedColumns.forEach( sc => 
      { exportCols.push(sc.field);
        // console.log('SAVEC CSV COL F ',sc.field);
        // console.log('SAVEC CSV COL ',sc);
      });
      exportCols.push('position');
      // console.log('SAVEC CSV SELECTED LOCATIONS ', this.selectedScales);
      // console.log('SAVEC CSV LOCATIONS ', this.scales);
      // console.log('SAVEC CSV EXPORT COL ', exportCols);
      this.exportService.exportToCsv(this.selectedScales, 'scales', exportCols);
   // this.exportService.exportToCsv(this.scales, 'scales', ['$key', 'name', 'description', 'tags', 'isEnabled', 'actions']);
  }

  saveAsExcelFile(buffer: any, fileName: string): void {
    let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    let EXCEL_EXTENSION = '.xlsx';
    const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE
    });
    FileSaver.saveAs(data, fileName + '_' + new Date().getTime() + EXCEL_EXTENSION);
  }

  // CRUD management
  openNew() {
    this.scale = {} as Scale;
    this.submitted = false;
    this.scaleDialog = true;
  }

  deleteSelectedScales() {
    this.confirmationService.confirm({
        message: 'Are you sure you want to delete the selected scales?',
        header: 'Confirm',
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
            this.scales = this.scales.filter(val => !this.selectedScales.includes(val));
            
            this.selectedScales.forEach( scale => this.scaleService.delete(scale.$key));
            this.selectedScales = [];
            this.messageService.add({severity:'success', summary: 'Successful', detail: 'Scaless Deleted', life: 3000});
        }
    });
  }

  editScale(scale: Scale) {
    this.scale = {...scale};
    this.scaleDialog = true;
  }

  deleteScale(scale: Scale) {
    this.confirmationService.confirm({
        message: 'Are you sure you want to delete ' + scale.name + '?',
        header: 'Confirm',
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
            this.scales = this.scales.filter(val => val.$key !== scale.$key);
            this.scale = {} as Scale;
            this.scaleService.delete(scale.$key);
            this.messageService.add({severity:'success', summary: 'Successful', detail: 'Scale Deleted', life: 3000});
        }
    });
  }

  hideDialog() {
    this.scaleDialog = false;
    this.submitted = false;
  }

  saveScale() {
    this.submitted = true;

    if ( this.scale.name.trim() ) {
      if (this.scale.$key) {
          this.scales[this.findIndexById(this.scale.$key)] = this.scale;                
          this.messageService.add({severity:'success', summary: 'Successful', detail: 'Scale Updated', life: 3000});
          this.scaleService.update(this.scale);
        } else {
          this.scale.position = this.scales.length;
          this.scaleService.add(this.scale);
      }
      this.messageService.add({severity:'success', summary: 'Successful', detail: 'Scale Created', life: 3000});
      this.scales = [...this.scales];
    }

    this.scaleDialog = false;
    this.scale = { } as Scale;
  }

  findIndexById(id: string): number {
    let index = -1;
    for (let i = 0; i < this.scales.length; i++) {
        if (this.scales[i].$key === id) {
            index = i;
            break;
        }
    } 
    return index;
  }

  filter( dt : Table, event : {target: any} ) {
    dt.filterGlobal( (event.target as HTMLInputElement).value, 'contains')
  }

  completeScale(scale : Scale) {
    this.scaleService.update(scale);
  }

  completePosition(scale : Scale) {
    if ( this.newPosition > -1 ) {
        scale.position = this.newPosition;
        scale = this.checkPositionLimits(scale);
        this.reorderElements(scale);
        //this.updateDB(scale);
        this.newPosition = -1;
        this.previousPosition = -1;
        return;
      }
  }


  @ViewChild('dt') tableElement: any; // already dt above
  isReordering : boolean = false;
  isAscReordering : boolean = false;
  isFilter : boolean = false;

  // Reorder
  reorder(event: any) {
    //console.log('Reorder event', event);
    // console.log('Before', this.scales);
    // const myClonedArray = [];
    // this.scales.forEach(val => myClonedArray.push(Object.assign({}, val)));
    // console.log('Before2', myClonedArray);
    if (event.dragIndex === event.dropIndex ) {
      return;
    }
    const startIndex = this.isAscReordering? event.dragIndex : this.scales.length - 1 - event.dragIndex;
    const endIndex   = this.isAscReordering? event.dropIndex : this.scales.length - 1 - event.dropIndex;
    const scaleToMove = this.scales[startIndex];

    if (startIndex < endIndex) {
      for(let index = startIndex; index < endIndex; index++) {
        this.scales[index] = this.scales[index+1];
        this.scales[index].position = index;
        this.scaleService.update(this.scales[index]);
      }     
    } else {
      for(let index = startIndex; index > endIndex; index--) {
        this.scales[index] = this.scales[index-1];
        this.scales[index].position = index;
        this.scaleService.update(this.scales[index]);
      }
    } 
    this.scales[endIndex] = scaleToMove;
    this.scales[endIndex].position = endIndex;
    this.scaleService.update(this.scales[endIndex]);
  }

  // onFieldEdit(scale: Spray, fieldName: string): void {
  //   //console.log(this.scales);
  //   console.log("Edit Init Event Called");
  //   console.log('Field name :'+fieldName);
  //   console.log('Field value :' + scale[fieldName]);
  //   if (fieldName === 'position') {
  //     if ( this.newPosition ) {
  //       scale.position = this.newPosition;
  //       scale = this.checkPositionLimits(scale);
  //       this.reorderElements(scale);
  //       //this.updateDB(scale);
  //       this.newPosition = undefined;
  //       this.previousPosition = undefined;
  //       return;
  //     }
      
  //   } else {
  //     this.updateDB(scale);
  //   }
  // }


  ngAfterViewInit() {
    this.dt.onSort.subscribe((data: { field: string; order: number; }) => {
        if (data.field && data.field === "position") {
          this.isReordering = true;
          this.isAscReordering = (data.order == 1);
          // console.log("ASC", this.isAscReordering);
          // console.log("data.order", data.order);
        } else {
          this.isReordering = false;
        }
    });
    this.dt.onFilter.subscribe( (data: {
      filteredValue: {
        [x: string]: any; field: string; order: number; 
}; field: string; order: number; 
}) => {
      if (data && data.filteredValue) {
        this.isFilter = !(this.scales.length === data.filteredValue['length']);
      } else {
        this.isFilter = false;
      }
  });
  
}


  previousPosition : number = -1;
  newPosition : number = -1;

  modelChangeFn(event: number, scale: Scale) {
    // console.log("event" +event);
    if (scale.position != null && scale.position > -1) {
      this.previousPosition = scale.position;
      this.newPosition = event;
    }
   
    // console.log("previous" +this.previousPosition);
    // console.log("new" +this.newPosition);
  }

  checkPositionLimits(scale: Scale) {
    console.log('check ',scale.position + ' ' + this.scales.length);
    if (!scale.position) {
     // console.log('check 1');
      return this.scale;
    }
    if (scale.position < 0) {
      scale.position = 0;
      // console.log('check 2');
      return scale;
    }
    if (scale.position > this.scales.length) {
      scale.position = this.scales.length - 1;
    //  console.log('check 3', scale.position);
      return scale;
    }
   // console.log('check 4');
    return scale;
  }

  async reorderElements(scale: Scale) {
    this.newPosition = this.newPosition  > this.scales.length ? this.scales.length - 1 : this.newPosition;
    this.newPosition = this.newPosition  < 0 ? 0 : this.newPosition;
    if (this.previousPosition === scale.position ) {
      return;
    }
    // console.log('Previous position: '+ this.previousPosition);
    // console.log('New position: '+ this.newPosition);
    const startIndex = this.previousPosition;
    const endIndex   = this.newPosition;
    const scaleToMove = this.scales[startIndex];
   // console.log('Item to move: ', this.scales[startIndex]);
    if (startIndex < endIndex) {
      for(let index = startIndex; index < endIndex; index++) {

        console.log('LOC', this.scales);
        console.log('Item to +1: ', this.scales[index+1]);

        this.scales[index] = this.scales[index+1];
        this.scales[index].position = index;
        // console.log('Move: ', this.scales[index+1]);
        // console.log('Move pos: ', this.scales[index].position);
        //await this.updateDB(this.scales[index]);
        this.scaleService.update(this.scales[index]);
     //   console.log('Update DB: ', this.scales[index]);
      }     
    } else {
      for(let index = startIndex; index > endIndex; index--) {
        this.scales[index] = this.scales[index-1];
        this.scales[index].position = index;
        this.scaleService.update(this.scales[index]);
      }
    } 
    this.scales[endIndex] = scaleToMove;
    this.scales[endIndex].position = endIndex;
    this.previousPosition = -1;
    this.newPosition = -1;
    this.scaleService.update(this.scales[endIndex]);
    
    // const myClonedArray = [];
    // this.scales.forEach(val => myClonedArray.push(Object.assign({}, val)));
    // this.scales = myClonedArray;
   // this.getAllRecords();
  }

}
